export default __webpack_public_path__ + "static/media/anyni3.fe65c9a1.jpeg";